import { ApiClientService, RequestConfig } from '@dfl/react-security';
import { CAMPAIGN_PAYMENT_PATH, CAMPAIGN_TYPE_ENUM } from 'modules/campaigns/constants';
import { ICheckResponse } from 'modules/common/interfaces/payment';
import { EntityApiService } from 'modules/common/service';
import { ICampaign, IPaymentPayload } from 'modules/campaigns/interfaces';
import omit from 'lodash/omit';

class CampaignPaymentService extends EntityApiService<any> {
  buy = async (data: IPaymentPayload, campaignType: CAMPAIGN_TYPE_ENUM, config?: RequestConfig): Promise<any> => {

    return await this.handleResponse(
      ApiClientService.post(
        this.getPath(
          `/${CAMPAIGN_PAYMENT_PATH[campaignType as keyof typeof CAMPAIGN_PAYMENT_PATH] || 'campaign'}/${
            data._id as string
          }`,
        ),
        omit(data?.payment || data, ['_id']),
        config,
      ),
    );
  };

  check = (
    data: ICampaign | string,
    campaignType: CAMPAIGN_TYPE_ENUM,
    config?: RequestConfig,
  ): Promise<ICheckResponse> => {
    const id = typeof data === 'string' ? data : data._id;
    return this.handleResponse(
      ApiClientService.post(
        this.getPath(
          `/${CAMPAIGN_PAYMENT_PATH[campaignType as keyof typeof CAMPAIGN_PAYMENT_PATH] || 'campaign'}/${
            id as string
          }/check`,
        ),
        {},
        config,
      ),
    );
  };
}

export default new CampaignPaymentService('/ms-business/api/payments');
